import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { NgxGalleryImage } from '@model/entities/ngx-gallery-image';
import * as Hammer from 'hammerjs';

@Component({
  selector: 'app-swiper',
  templateUrl: './swiper.component.html',
  styleUrls: ['./swiper.component.scss']
})
export class SwiperComponent implements OnInit {
  @ViewChild('swiperElement', { static: false }) swiperRef?: ElementRef;
  @ViewChild('thumbnailSwiper', { static: false }) thumbnailSwiperRef?: ElementRef;

  @Input()
  public galleryImages: NgxGalleryImage[] = [];

  isFullscreen: boolean = false;
  activeIndex: number = 0;

  constructor() { }

  ngOnInit(): void { }

  setSwiperIndex(event: any): void {
    this.activeIndex = event.target.swiper.activeIndex;
    this.syncThumbnailSwiper(this.activeIndex);
  }

  syncMainSwiper(event: any): void {
    const index = event.target.swiper.activeIndex;
    this.swipeTo(index);
  }

  swipeTo(index: number): void {
    const mainSwiper = this.swiperRef?.nativeElement.swiper;
    const thumbnailSwiper = this.thumbnailSwiperRef?.nativeElement.swiper;

    mainSwiper.slideTo(index);
    thumbnailSwiper.slideTo(index);
  }

  syncThumbnailSwiper(index: number): void {
    const thumbnailSwiper = this.thumbnailSwiperRef?.nativeElement.swiper;
    if (thumbnailSwiper) {
      thumbnailSwiper.slideTo(index);
    }
  }

  initHammer(): void {
    const imgElements = document.querySelectorAll('.zoomable-image');
    const swiper = this.swiperRef?.nativeElement.swiper;

    imgElements.forEach((img: HTMLElement) => {
      const hammer = new Hammer(img);
      hammer.get('pinch').set({ enable: true });

      let currentX = 0;
      let currentY = 0;
      let initRect = null;
      let screenThird = 'center';
      let scale = 1;

      hammer.on('pinchstart', () => {
        scale = 2;
        img.style.transform = `translate(${currentX}px, ${currentY}px) scale(${scale})`;
        initRect = img.getBoundingClientRect();

        if (swiper) {
          swiper.disable();
        }
      });

      hammer.on('pinch', (ev) => {
        const screenWidth = window.innerWidth;
        if (ev.center.x < screenWidth / 3) {
          screenThird = 'left';
          currentX = -initRect.left / 2;
        } else if (ev.center.x > (2 * screenWidth) / 3) {
          screenThird = 'right';
          currentX = initRect.left / 2;
        } else {
          screenThird = 'center';
          currentX = 0;
        }

        img.style.transform = `translate(${currentX}px, ${currentY}px) scale(${scale})`;
      });

      hammer.on('pinchend', () => {
        scale = 1;
        currentX = 0;
        currentY = 0;
        img.style.transform = `translate(${currentX}px, ${currentY}px) scale(${scale})`;
        if (swiper) {
          swiper.enable();
        }
      });
    });
  }

  toggleFullscreen(): void {
    this.isFullscreen = !this.isFullscreen;
  }
}
